import React, { Fragment } from 'react';
import { useIntl } from 'react-intl/dist';
import classnames from 'classnames';

import { normalizeDefaultToNull } from '../../utils/normalize/normalizeDefaultToNull';


const DropdownWithTwoLabels = props => {

    const {
        inputActions: {
            handleFieldChange
        },
        inputData: {
            disabled,
            id,
            isInputRequired = false,
            name,
            options,
            type,
            value
        },
        label: {
            leftLabel: {
                text: leftLabelText
            },
            rightLabel: {
                text: rightLabelText
            }
        }
    } = props;

    const intlApi = useIntl();

    const selectText = intlApi.formatMessage({ id: 'ssap.input.option.select' });

    const handleValueChange = e => {
        const { value } = e.target;

        const text = (
            o => o
                ? (o.value === 'default' ? null: o.text)
                : null
        )(options.find(o => o.value === value));

        let valueForSaving;

        switch(true) {
            case value === 'default':
                valueForSaving = normalizeDefaultToNull(value); break;
            default:
                valueForSaving = value;
        }

        handleFieldChange(valueForSaving, text);
    };

    const adjustedValue = (value === undefined || value === null || value === '')
        ? 'default'
        : value;

    const componentClassnames = classnames(
        'grid-row',
        'gi-component',
        'margin-bottom-1em',
        `gi-${ type }`
    );

    const leftLabelClassNames = classnames(
        'tablet:grid-col-4',
        `gi-${ type }__label`
    );

    const inputClassNames = classnames(
        'tablet:grid-col-4',
        `gi-${ type }__select`
    );

    const rightLabelClassNames = classnames(
        'tablet:grid-col-4',
        `gi-${ type }__label`,
        `gi-${ type }__text-align-left`,
        { [ `required-${ isInputRequired }` ]: isInputRequired }
    );

    const getOptions = () => {
        return options.map((option, idx) => {
            const { text: optionText, value: optionValue } = option;

            return (
                <option
                    data-testid = { `${ id }_${ optionValue }` }
                    key = { `${ optionValue }_${ idx }` }
                    value = { optionValue }
                >
                    {
                        value === '' && optionValue === 'default' ?
                            selectText :
                            optionText
                    }
                </option>
            );
        });
    };

    return (
        <Fragment>
            <div className = { componentClassnames } >
                <label
                    className = { leftLabelClassNames }
                    htmlFor = { id }
                    id = { `segment1-${ id }` }
                >
                    { leftLabelText }
                </label>
                <select
                    aria-labelledby = { `segment1-${ id } ${ id } segment2-${ id }` }
                    aria-required = { isInputRequired }
                    className = { inputClassNames }
                    data-testid = { id }
                    disabled = { disabled }
                    id = { id }
                    name = { name }
                    onChange = { handleValueChange }
                    value = { adjustedValue }
                >
                    { getOptions() }
                </select>
                <span
                    className = { rightLabelClassNames }
                    id = { `segment2-${ id }` }
                >
                    { rightLabelText }
                </span>
            </div>
        </Fragment>
    );
};

export default DropdownWithTwoLabels;
